import React from 'react'
import withRedux from 'next-redux-wrapper'
import Theme from 'components/Theme'
import { Actions as PageActions } from 'actions/page'
import { App, Store } from 'apps/public/trade'
import { getMetaData } from 'apps/public/trade/selectors'
import { storeSetup } from 'lib/pageSetup'

const Trade = (): React.ReactElement<React.ComponentProps<any>, any> => (
  <Theme>
    <App />
  </Theme>
)

Trade.getInitialProps = async ({ req, store, query }): Record<string, any> => {
  const section = query.section || ''

  // Client-Side
  if (!req) {
    store.dispatch(
      PageActions.SET_PARAMS({
        section,
      })
    )
    const state = { ...store.getState() }
    const metaData = getMetaData(state)
    return {
      metaData,
    }
  }

  // SSR
  storeSetup(store, req)
  // Set PAGE data passed from Express Route
  const { originalUrl } = req
  const pageData = {
    name: 'public/trade',
    params: {
      section,
    },
    path: originalUrl,
  }
  store.dispatch(PageActions.SET(pageData))
  // Metadata & Datalayer
  const state = { ...store.getState() }
  const metaData = getMetaData(state)
  return {
    dataLayer: {
      event: 'pagetype',
      pagetype: 'Trade',
    },
    metaData,
  }
}

export default withRedux(Store)(Trade)